import { Modal, Text, Stack, Group, Divider, Anchor, Badge, Card, Box, ActionIcon, Center, Loader } from "@mantine/core";
import { IconDownload, IconFile, IconLink } from "@tabler/icons-react";
import { base64ToBlob, downloadFile, fetchFile, openFileInNewTab } from "../utils/fileService";
import { useSelector } from "react-redux";
import { useState } from "react";

const getFileIcon = (tipoArchivo) => {
  if (tipoArchivo === "url") return <IconLink size={18} style={{minWidth:'20px'}}/>;
  return <IconFile size={18} style={{minWidth:'20px'}}/>;
};

const ModalEvidence = ({ opened, onClose, evidence }) => {
  const { user } = useSelector((state) => state.auth);
  const [downloadingFiles, setDownloadingFiles] = useState(new Set());
  
  if (!evidence) return null;

  const mainFile = evidence.archivos.find((a) => a.esPrincipal)
  const secondaryFiles = evidence.archivos.filter((a) => !a.esPrincipal)

  const handleDownloadEvidence = async (fileId, fileName, fileType, downloadType = 'download') => {
    
    setDownloadingFiles(prev => new Set(prev).add(fileId));
    try {
      const fileData = await fetchFile(fileId, user.token);
      if (!fileData) return;
      const fileBlob = base64ToBlob(fileData, fileType || 'application/pdf');

      if (downloadType === 'tab'){
        openFileInNewTab(fileBlob);
      }else{
        downloadFile(fileBlob, fileName);
      }
      
    } catch (error) {
      console.error('Error al descargar el archivo:', error);
    } finally {
      // Remover el archivo del set de descargas en progreso
      setDownloadingFiles(prev => {
        const newSet = new Set(prev);
        newSet.delete(fileId);
        return newSet;
      });
    }
  };
  
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={<Text fw={500} size="lg">Detalle de evidencia</Text>}
      size="lg"
      radius="md"
      centered
    >
      <Stack gap="md" p={'md'}>
        <Box>
          <Text size="xs" c={'dimmed'}>Titulo</Text>
          <Text >{evidence.titulo}</Text>
        </Box>
        <Box>
          <Text size="xs" c={'dimmed'}>Descripcion</Text>
          <Text>{evidence.descripcion}</Text>
        </Box>
        <Card withBorder radius="md" p="sm">
          <Group justify="space-between" wrap="nowrap">
            <Center inline>
              {getFileIcon(mainFile.tipoArchivo)}
              <Text ml={10}>{mainFile.nombre}</Text>
            </Center>
            <ActionIcon 
              radius={'md'} 
              color="#e72166" 
              title="Descargar" 
              onClick={() => handleDownloadEvidence(mainFile.Id, mainFile.nombre, mainFile.tipoArchivo, 'tab')}
              loading={downloadingFiles.has(mainFile.Id)}
              disabled={downloadingFiles.has(mainFile.Id)}
            >
              {downloadingFiles.has(mainFile.Id) ? (
                <Loader size="xs" color="white" />
              ) : (
                <IconDownload height={'70%'} width={'70%'}/>
              )}
            </ActionIcon>
          </Group>
          {mainFile.descripcion && (
            <Text size="sm" c="dimmed">
              {mainFile.descripcion}
            </Text>
          )}
        </Card>
        <Box>
          <Text size="xs" c={'dimmed'}>Unidad de Gestion</Text>
          <Text>{evidence.unidadesGestion[0]?.codigoUnidadGestion} - {evidence.unidadesGestion[0]?.codigoSede}</Text>
        </Box>

        <Divider label={<Text span size="md">KPIs</Text>} size={'sm'} labelPosition="center" mt={'lg'}/>
        <Stack gap="sm">
          {evidence.kpis?.map((kpi) => (
            <Card key={kpi.Id} withBorder radius="md" p="sm" bg={'#fbfbfbff'}>
              <Text fw={500} size="sm" c={'#e72166'}>KPI {kpi.numKpi}.</Text>
              <Text fw={500}>{kpi.titulo}</Text>
              <Text size="sm">{kpi.descripcion}</Text>
              <Group gap="xs" mt="xs">
                <Badge color="blue" size="sm">{kpi.categoria}</Badge>
                <Badge color="teal" size="sm">{kpi.tipo}</Badge>
              </Group>
            </Card>
          ))}
        </Stack>

        <Divider label={<Text span size="md">Anexos</Text>} size={'sm'} labelPosition="center" mt={'lg'}/>
        <Stack gap="sm">
          {secondaryFiles?.sort((a, b) => new Date(a.esArchivo) - new Date(b.esArchivo)).map((anexo) => (
            <Card key={anexo.Id} withBorder radius="md" p="sm">
              <Group justify="space-between" wrap="nowrap">
                <Group wrap="nowrap">
                  {getFileIcon(anexo.tipoArchivo)}
                  <Stack gap={5}>
                    {anexo.esArchivo ? (
                      <Text>{anexo.nombre}</Text>
                    ) : (
                      <Anchor href={anexo.url} target="_blank" style={{ wordBreak: 'break-word' }}> {anexo.nombre} </Anchor>
                    )}
                    {anexo.descripcion && (
                      <Text size="sm" c="dimmed">
                        {anexo.descripcion}
                      </Text>
                    )}
                  </Stack>
                </Group>
                {anexo.tamanio && (
                  <ActionIcon 
                    radius={'md'} 
                    color="#e72166" 
                    title="Descargar" 
                    onClick={() => handleDownloadEvidence(anexo.Id, anexo.nombre, anexo.tipoArchivo, 'tab')}
                    loading={downloadingFiles.has(anexo.Id)}
                    disabled={downloadingFiles.has(anexo.Id)}
                  >
                    {downloadingFiles.has(anexo.Id) ? (
                      <Loader size="xs" color="white" />
                    ) : (
                      <IconDownload height={'70%'} width={'70%'}/>
                    )}
                  </ActionIcon>
                )}
              </Group>
            </Card>
          ))}
        </Stack>
      </Stack>
    </Modal>
  );
}

export default ModalEvidence;
